import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import {
// editCollectionInfo,
getCollectionInfo } from '@/service/operate/comprehensiveDaily';
export default function useCollectionCorrection(params) {
  var collectionInfo = ref({
    factory_id: 0,
    collect_date: '',
    update_time: '',
    deleted: 0,
    create_time: '',
    concrete_collect: 0,
    stone_collect: 0,
    id: 0,
    mortar_collect: 0 // 砂浆收款（元）
  });
  var collectionList = computed(function () {
    return [{
      title: '骨料',
      value: collectionInfo.value.stone_collect
    }, {
      title: '砂浆',
      value: collectionInfo.value.mortar_collect
    }, {
      title: '商砼',
      value: collectionInfo.value.concrete_collect
    }];
  });
  var getCollectionInfoAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getCollectionInfo(params.value);
          case 2:
            data = _context.sent;
            collectionInfo.value = data;
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function getCollectionInfoAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  return [collectionInfo, getCollectionInfoAsync, collectionList];
}